var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileEditInfo.jinja');
require('./MemberProfileEditInfo.less');

module.exports = Base.extend({

    template: template,

    events: {
        'click .MemberProfileEditInfo-buttons-button--cancel': 'cancelEdit',
        'click .MemberProfileEditInfo-buttons-button--save': 'saveEdit',
        'change .MemberProfileEditInfo-body-header-userpicInput': 'changeUserpic',
        'click .MemberProfileEditInfo-body-header-userpicDelete': 'deleteUserpic',
        'change .MemberProfileEditInfo-body-inputs-inputResume': 'changeResume',
        'click .MemberProfileEditInfo-body-inputs-resume-filename-delete': 'deleteResume',
        'change .MemberProfileEditInfo-body-inputs-inputWrapper input[type="checkbox"]': 'onVisibilityChange',
        'change select[name="address_country"]': 'updateAddressStateVisibility',
        'change select[name="location_country"]': 'updateLocationStateVisibility',
        'change input[type="radio"]': 'onRadioChange',
        'focus input': 'resetError',
        'focus select': 'resetError',
    },

    tempFilesApi: function () {
        return (Urls['front:api:files:temp-file-upload']());
    },


    onRadioChange: function (e) {
        app.utils.fixSafariRadioRepaint(e);
    },


    saveApi: function () {
        return Urls['member:api:member'](this.options.memberId, 'json');
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this,  'saveApi', 'tempFilesApi');

        //extract filename from full path
        var resumeFilename = this.$('.MemberProfileEditInfo-body-inputs-inputResume').attr('data-file');
        if (resumeFilename) {
            resumeFilename = resumeFilename.split('/');
            this.$('.MemberProfileEditInfo-body-inputs-resume-filename-name').text(resumeFilename[resumeFilename.length - 1]);
        }

        this.updateAddressStateVisibility();
        this.updateLocationStateVisibility();

        Base.prototype.initialize.call(this, options);
    },


    updateAddressStateVisibility: function () {
        var $form = this.$('.MemberProfileEditInfo-bodyForm');
        var country = $('select[name="address_country"]', $form).val();
        var $state = $('select[name="address_state"]', $form);
        var isUSA = country == 470;

        $state.toggleClass('MemberProfileEditInfo-body-inputs-input--disabled', !isUSA); // 470 USA
        $state.closest('.MemberProfileEditInfo-body-inputsBlock').toggleClass('MemberProfileEditInfo-body-inputsBlockState--disabled', !isUSA);

        this.resetError({target: $('select[name="address_state"]', $form)});

        if (!isUSA) {
            $state.val(0);
        }
    },


    updateLocationStateVisibility: function () {
        var $form = this.$('.MemberProfileEditInfo-bodyForm');
        var country = $('select[name="location_country"]', $form).val();
        var $state = $('select[name="location_state"]', $form);
        var isUSA = country == 470;

        $state.toggleClass('MemberProfileEditInfo-body-inputs-input--disabled', !isUSA); // 470 USA
        $state.closest('.MemberProfileEditInfo-body-inputsBlock').toggleClass('MemberProfileEditInfo-body-inputsBlockState--disabled', !isUSA);

        if (!isUSA) {
            $state.val(0);
        }
    },


    setError: function ($input, hasErrors) {
        $input.addClass('MemberProfileEditInfo-body-inputs-input--error');
        $input.closest('.MemberProfileEditInfo-body-inputsBlock')
            .find('.MemberProfileEditInfo-body-inputs-inputName')
            .addClass('MemberProfileEditInfo-body-inputs-inputName--error');
        $input.attr('placeholder', 'this field is required')

        // scroll to first error
        if (!hasErrors) {
            if (!app.settings.isPhone) {
                app.animateWindowScroll( $input.offset().top - 70);
            } else {
                $('.MemberProfileEdit-scrollbox').animate({'scrollTop': $input.offset().top + $('.MemberProfileEdit-scrollbox')[0].scrollTop - window.pageYOffset - 70}, 400);
            }
        }
    },

    resetError: function (e) {
        var $input = $(e.target);
        if ($input.hasClass('MemberProfileEditInfo-body-inputs-input--error')) {
            $input.removeClass('MemberProfileEditInfo-body-inputs-input--error');
            $input.closest('.MemberProfileEditInfo-body-inputsBlock')
                .find('.MemberProfileEditInfo-body-inputs-inputName')
                .removeClass('MemberProfileEditInfo-body-inputs-inputName--error');
            $input.attr('placeholder', '')
        }
    },


    deactivate: function (params) {
        this.resetResumeLoading();

        this.resetUserpicLoading();

        return Base.prototype.deactivate.call(this, params);
    },


    onVisibilityChange: function (e) {
        var $block = $(e.currentTarget).closest('.MemberProfileEditInfo-body-inputsBlock');
        $block.toggleClass('hidden', $(e.currentTarget).is(':checked'));
    },


    saveEdit: function () {
        var hasErrors = false;
        var data = {};
        var memberData = window.app.data.members[this.options.memberId];
        var $form = this.$('.MemberProfileEditInfo-bodyForm');


        var $userpicInput = this.$('.MemberProfileEditInfo-body-header-userpicInput');
        var userpicFileData = $userpicInput.attr('data-file');
        data.userpic = userpicFileData ? JSON.parse(userpicFileData) : null;


        data.email = $('input[name="email"]', $form).val();
        data.emailPublic = $('input[name="emailPublic"]', $form)[0].checked ? 15 : 14; //15-private, 14-public

        if (!$.trim(data.email)) {
            this.setError($('input[name="email"]', $form), hasErrors);
            hasErrors = true;
        }

        data.home = $('input[name="home"]', $form).val();
        data.homePublic = $('input[name="homePublic"]', $form)[0].checked ? 15 : 14; //15-private, 14-public

        data.cell = $('input[name="cell"]', $form).val();
        data.cellPublic = $('input[name="cellPublic"]', $form)[0].checked ? 15 : 14; //15-private, 14-public

        if (!$.trim(data.cell)) {
            this.setError($('input[name="cell"]', $form), hasErrors);
            hasErrors = true;
        }

        data.imdb = $('input[name="imdb"]', $form).val();
        data.imdbPublic = $('input[name="imdbPublic"]', $form)[0].checked ? 15 : 14; //15-private, 14-public

        data.website = $('input[name="website"]', $form).val();
        data.websitePublic = $('input[name="websitePublic"]', $form)[0].checked ? 15 : 14; //15-private, 14-public

        /*eslint-disable */
        data.website2 = $('input[name="website2"]', $form).val();
        data.website2_public = $('input[name="website2_public"]', $form)[0].checked ? 15 : 14; //15-private, 14-public

        data.website3 = $('input[name="website3"]', $form).val();
        data.website3_public = $('input[name="website3_public"]', $form)[0].checked ? 15 : 14; //15-private, 14-public
        /*eslint-enable */

        var $resumeInput = this.$('.MemberProfileEditInfo-body-inputs-inputResume');
        var resumeFileData = $resumeInput.attr('data-file');
        data.resume = resumeFileData ? ($resumeInput.attr('data-new') ? JSON.parse(resumeFileData) : resumeFileData) : null;


        data.address = {
            'address1': $('input[name="address_address1"]', $form).val(),
            'address2': $('input[name="address_address2"]', $form).val(),
            'city': $('input[name="address_city"]', $form).val(),
            'country': $('select[name="address_country"]', $form).val(),
            'state': $('select[name="address_state"]', $form).val(),
            'zip': $('input[name="address_zip"]', $form).val(),
            'confidential': memberData.address ? memberData.address.confidential : null,
            'id': memberData.address ? memberData.address.id : null
        };

        if (!$.trim(data.address.address1)) {
            this.setError($('input[name="address_address1"]', $form), hasErrors);
            hasErrors = true;
        }
        if (!$.trim(data.address.city)) {
            this.setError($('input[name="address_city"]', $form), hasErrors);
            hasErrors = true;
        }
        if (!$.trim(data.address.zip)) {
            this.setError($('input[name="address_zip"]', $form), hasErrors);
            hasErrors = true;
        }
        if (data.address.country == 0) {
            this.setError($('select[name="address_country"]', $form), hasErrors);
            hasErrors = true;
        }
        var isUSA = data.address.country == 470;
        if (isUSA && data.address.state == 0) {
            this.setError($('select[name="address_state"]', $form), hasErrors);
            hasErrors = true;
        }

        data.location = {
            'address1': $('input[name="location_address1"]', $form).val(),
            'address2': $('input[name="location_address2"]', $form).val(),
            'city': $('input[name="location_city"]', $form).val(),
            'country': $('select[name="location_country"]', $form).val(),
            'state': $('select[name="location_state"]', $form).val(),
            'zip': $('input[name="location_zip"]', $form).val(),
            'confidential': memberData.location ? memberData.location.confidential : null,
            'id': memberData.location ? memberData.location.id : null
        };

        //all social data made Public (14)
        //if previously it was Private in winmill we set input to '' in jinja
        data.facebook = $('input[name="facebook"]', $form).val();
        data.facebookPublic = 14;

        data.twitter = $('input[name="twitter"]', $form).val();
        data.twitterPublic = 14;

        data.instagram = $('input[name="instagram"]', $form).val();
        data.instagramPublic = 14;

        data.linkedin = $('input[name="linkedin"]', $form).val();
        data.linkedinPublic = 14;

        data.youtube = $('input[name="youtube"]', $form).val();
        data.youtubePublic = 14;

        data.vimeo = $('input[name="vimeo"]', $form).val();
        data.vimeoPublic = 14;



        data.agentDetails = {
            'agency': $('input[name="agentDetails_agency"]', $form).val(),
            'cell': $('input[name="agentDetails_cell"]', $form).val(),
            'contact': $('input[name="agentDetails_contact"]:checked', $form).val() == '0' ? false : true,
            'email': $('input[name="agentDetails_email"]', $form).val(),
            'fax': $('input[name="agentDetails_fax"]', $form).val(),
            'name': $('input[name="agentDetails_name"]', $form).val(),
            'phone': $('input[name="agentDetails_phone"]', $form).val()
        };

        if (hasErrors) {
            return;
        }

        var $button = this.$('.MemberProfileEditInfo-buttons-button--save');

        $button.addClass('Button--loading');

        this.saveXhr = $.ajax({
            url: this.saveApi(),
            method: 'PATCH',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data),
            success: function (responseData) {

                app.vent.trigger('need-reload', 'my-adg');// refresh my-adg page if it's current underlying page, to update member info block on it

                $button.removeClass('Button--loading');

                //save response to cache, it's important for all popup edit panels, which renders on the fly to show actual data
                //response always contain all profile data up-to-date
                window.app.data.members[this.options.memberId] = responseData;

                window.app.vent.trigger('MemberProfile--updateInfo', this.options.memberId);

                this.cancelEdit();
            },
            error: function (e, tp) {
                $button.removeClass('Button--loading');

                if (tp != 'abort') {
                    alert('Can\'t save profile!');
                }

                console.log('error', arguments);
            },
            context: this
        });
    },


    cancelEdit: function () {
        this.saveXhr && this.saveXhr.abort();

        window.app.vent.trigger('MemberProfileEdit--close', 'info');
    },


    changeUserpic: function (e) {
        if (!e.target.files || !e.target.files.length) return;

        this.resetUserpicLoading();

        var $input = $(e.currentTarget);
        var $wrapper = this.$('.MemberProfileEditInfo-body-header-userpic');
        var $img = $wrapper.find('.MemberProfileEditInfo-body-header-userpicImg');
        var fil = e.target.files[0];
        var self = this;

        $wrapper.attr('data-state', 'loading');
        $input.attr('data-file', '');

        this.userpicLoadXhr = new XMLHttpRequest();
        this.userpicLoadXhr.open('POST', this.tempFilesApi());

        this.userpicLoadXhr.onload = function (res, data) {
            var responseObject = app.AdoptTempFileObject(this.responseText, 'image');

            $input.attr('data-file', JSON.stringify(responseObject));
            $input.attr('data-new', '1');
            $wrapper.attr('data-state', 'loaded');

            $img.attr('src', responseObject.tempImg);
        };

        this.userpicLoadXhr.onerror = function () {
            $wrapper.attr('data-state', 'error');
        };

        var formData = new FormData();
        formData.append('file', fil);
        this.userpicLoadXhr.send(formData);

        $input.val('');
    },


    deleteUserpic: function (e) {
        var $wrapper = this.$('.MemberProfileEditInfo-body-header-userpic');
        var $input = $wrapper.find('input[type="file"]');
        var $img = $wrapper.find('.MemberProfileEditInfo-body-header-userpicImg');

        $wrapper.attr('data-state', 'empty');
        $input.attr('data-file', '');
        $wrapper.removeAttr('src');

        this.resetUserpicLoading();
    },


    resetUserpicLoading: function () {
        this.userpicLoadXhr && this.userpicLoadXhr.abort();
    },






    changeResume: function (e) {
        if (!e.target.files || !e.target.files.length) return;

        this.resetResumeLoading();

        var $input = $(e.currentTarget);
        var $wrapper = $input.closest('.MemberProfileEditInfo-body-inputs-inputWrapper');
        var $filenameWrapper = $wrapper.find('.MemberProfileEditInfo-body-inputs-resume-filename');
        var $filename = $filenameWrapper.find('.MemberProfileEditInfo-body-inputs-resume-filename-name');
        var fil = e.target.files[0];
        var self = this;

        $filenameWrapper.attr('data-state', 'loading');
        $input.attr('data-file', '');
        $filename.text(fil.name);

        this.resumeLoadXhr = new XMLHttpRequest();
        this.resumeLoadXhr.open('POST', this.tempFilesApi());

        this.resumeLoadXhr.onload = function (res, data) {
            var responseObject = app.AdoptTempFileObject(this.responseText, 'file');

            $input.attr('data-file', JSON.stringify(responseObject));
            $input.attr('data-new', '1');
            $filenameWrapper.attr('data-state', 'loaded');
        };

        this.resumeLoadXhr.onerror = function () {
            $filenameWrapper.attr('data-state', 'error');
        };

        var formData = new FormData();
        formData.append('file', fil);
        this.resumeLoadXhr.send(formData);

        $input.val('');
    },


    deleteResume: function (e) {
        var $wrapper = $(e.currentTarget).closest('.MemberProfileEditInfo-body-inputs-inputWrapper');
        var $input = $wrapper.find('input[type="file"]');
        var $filenameWrapper = $wrapper.find('.MemberProfileEditInfo-body-inputs-resume-filename');
        var $filename = $filenameWrapper.find('.MemberProfileEditInfo-body-inputs-resume-filename-name');

        $filenameWrapper.attr('data-state', 'empty');
        $input.attr('data-file', '');
        $filename.text('');

        this.resetResumeLoading();
    },


    resetResumeLoading: function () {
        this.resumeLoadXhr && this.resumeLoadXhr.abort();
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditInfo.js
// module id = 214
// module chunks = 0